<h2>{{ 'popins.duplicate.title' | translate }}</h2>
<p class="mt-2 mb-4">{{ 'popins.duplicate.info' | translate }}</p>
<p class="custom-form-row" [class.error]="currentError > 0">
    <label for="input-duplicate-name">{{ 'popins.duplicate.label1' | translate }}</label>
    <input type="text" [(ngModel)]="currentName" id="input-duplicate-name" autocorrect="off" spellcheck="false">
</p>
<p class="form-message-error" *ngIf="currentError > 0">{{ ('popins.duplicate.error_'+currentError) | translate }}</p>
<div class="text-center mt-3">
    <ng-hbm-bdi-btn class="light-grey mr-3" (click)="cancel()" [label]="'generic.cancel' | translate"></ng-hbm-bdi-btn>
    <ng-hbm-bdi-btn class="primary" (click)="submit()" [label]="'generic.duplicate' | translate"></ng-hbm-bdi-btn>
</div>